import device from './device'
import storeLinks from './storeLinks'


const currentStoreLink = device.isAndroid ? storeLinks.playStore : storeLinks.appStore


export default currentStoreLink
